export default __webpack_public_path__ + "static/media/LUSD.5972948a.svg";